import { useMemo, useState } from 'react';

export const useFilteredSlidesPagination = ({ slides, countPerPage }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const currentSlides = useMemo(
    () =>
      slides?.slice(
        (currentPage - 1) * countPerPage,
        countPerPage * currentPage,
      ),
    [countPerPage, currentPage, slides],
  );
  const totalPages = slides?.length
    ? Math.ceil(slides.length / countPerPage)
    : 0;
  const showPagination = !!totalPages && totalPages > 1;

  const onChangePage = (evt, value) => {
    setCurrentPage(value);
  };

  return {
    currentPage,
    totalPages,
    showPagination,
    currentSlides,
    onChangePage,
  };
};
